import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Container,
  CircularProgress
} from '@mui/material';

interface InvitationLoadingScreenProps {
  code?: string;
}

export const InvitationLoadingScreen: React.FC<InvitationLoadingScreenProps> = ({
  code
}) => {
  return (
    <Container component="main" maxWidth="md">
      <Box sx={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <Card sx={{
          width: '100%',
          textAlign: 'center',
          p: 4
        }}>
          <CardContent>
            <CircularProgress sx={{ mb: 2 }} />
            <Typography variant="h6">
              Cargando código de invitación...
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Verificando código: {code}
            </Typography>
          </CardContent>
        </Card>
      </Box>
    </Container>
  );
};
